import { NETWORKS } from "../../../lib/share";
import { StatCard } from "../ui";

/** Paso 5 · clics en los enlaces del distribuidor. */
export const ClickStats = ({ stats, materials }) => {
  const top = Object.entries(stats.by_slug || {}).sort((a, b) => b[1] - a[1]).slice(0, 5);
  const title = (slug) => materials.find((m) => m.slug === slug)?.title || slug;
  return (
    <div data-testid="click-stats">
      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        <StatCard dark label="Clics en tus enlaces" value={stats.total_clicks} testId="stats-clicks" />
        <StatCard label="Veces que compartiste" value={stats.shares} testId="stats-shares" />
        {NETWORKS.slice(0, 2).map(({ id, label }) => <StatCard key={id} label={`Clics desde ${label}`} value={stats.by_network?.[id] || 0} testId={`stats-net-${id}`} />)}
      </div>
      <div className="mt-4 grid gap-3 md:grid-cols-2">
        <div className="rounded-2xl border border-ink/10 bg-white p-4">
          <p className="font-mono text-xs uppercase tracking-[0.14em] text-leaf-deep">Material que más abren</p>
          {!top.length && <p className="mt-2 text-sm text-ink/60" data-testid="stats-empty">Aún no hay clics. Comparte tu primer material hoy.</p>}
          <ul className="mt-2 space-y-1.5">
            {top.map(([slug, n], i) => (
              <li key={slug} className="flex items-center justify-between text-sm" data-testid={`stats-top-${i}`}><span className="truncate pr-3">{title(slug)}</span><strong>{n}</strong></li>
            ))}
          </ul>
        </div>
        <div className="rounded-2xl border border-ink/10 bg-white p-4">
          <p className="font-mono text-xs uppercase tracking-[0.14em] text-leaf-deep">Clics por red</p>
          <ul className="mt-2 space-y-1.5">
            {NETWORKS.map(({ id, label, Icon, color }) => (
              <li key={id} className="flex items-center justify-between text-sm"><span className="inline-flex items-center gap-2"><Icon className="h-4 w-4" style={{ color }} /> {label}</span><strong>{stats.by_network?.[id] || 0}</strong></li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
